import React, { useEffect, useRef, useState } from 'react';
import { Button, Icon, InputNumber, Select, Input, Tooltip } from '@kdcloudjs/kdesign'
import GridLayout from "react-grid-layout";
import makeCheckModal from "../components/checkModal"
import { lastShowInfo, isImg } from "./utils"

import "./editCard.less"
import "./cardStyle.less"

const numInpStyle = { width: "unset", marginRight: "8px" }
const tipsIconStyle = { fontSize: "12px", color: "#ddd" }
const fontSizeStyle = { width: "66px" }

const cardW = 180;

const maxH = 100
const maxW = cardW
const minH = 20
const minW = 20

function EditCard(props) {
    console.log("edit props", props);

    const { editCancel, currCardModel, fields, selectModal, cardStyle, I18N } = props

    const [layouts, setLayouts] = useState(() => {
        return currCardModel.map(item => {
            const _item = JSON.parse(JSON.stringify(item))
            _item.maxH = maxH
            _item.maxW = maxW
            _item.minH = minH
            _item.minW = minW
            return _item
        })
    })

    const [dataMap, setDataMap] = useState(() => {
        const map = {}
        currCardModel.forEach(item => {
            map[item.i] = JSON.parse(JSON.stringify(item))
        })
        return map
    })

    const [currGridItem, setCurrGridItem] = useState(null)

    const [currItemData, setCurrItemData] = useState(null)

    const wdithRef = useRef()

    const heightRef = useRef()

    const [wtipsDis, setWtipsDis] = useState("none")

    const [htipsDis, setHtipsDis] = useState("none")

    const cancelHanle = () => {
        editCancel()
    }

    const sureHandle = () => {
        const model = layouts.map(item => {
            const { aftercontent, align, beforecontent, bold, fontSize, name, showInfo } = dataMap[item.i]
            return {
                i: item.i + "",
                x: item.x,
                y: item.y,
                w: item.w,
                h: item.h,
                aftercontent,
                align,
                beforecontent,
                bold,
                fontSize,
                name,
                showInfo
            }
        })

        if (model.length === 0) return

        selectModal(model)
    }

    const onLayoutChange = layout => {
        setLayouts(layout)
    }

    const clickCurrGrid = item => {
        console.log("clickCurrGrid", dataMap[item.i]);


        setCurrGridItem(item)
        setCurrItemData(dataMap[item.i])
    }

    const selectAlign = align => {
        setCurrItemData(currItemData => {
            currItemData.align = align
            return {
                ...currItemData
            }
        })
    }

    const changeBold = () => {
        setCurrItemData(currItemData => {
            currItemData.bold = !currItemData.bold
            return {
                ...currItemData
            }
        })
    }

    const selectFontSize = fontSize => {
        setCurrItemData(currItemData => {
            currItemData.fontSize = fontSize
            return {
                ...currItemData
            }
        })
    }

    const changeBeforecontent = e => {
        e.persist()
        setCurrItemData(currItemData => {
            currItemData.beforecontent = e.target.value
            return {
                ...currItemData
            }
        })
    }

    const changeAftercontent = e => {
        e.persist()
        setCurrItemData(currItemData => {
            currItemData.aftercontent = e.target.value
            return {
                ...currItemData
            }
        })
    }

    const changeWidth = e => {
        setCurrItemData(currItemData => {
            currItemData.w = parseInt(e.target.value) || 0
            return {
                ...currItemData
            }
        })
    }

    const setWidth = w => {
        if (w >= minW && w <= maxW) {
            layouts.find(item => {
                if (item.i === currItemData.i) {
                    item.w = w
                }
            })

            setLayouts(JSON.parse(JSON.stringify(layouts)))

            setCurrItemData(currItemData => {
                currItemData.w = w
                return {
                    ...currItemData
                }
            })
        }

    }

    const changeHeight = e => {
        setCurrItemData(currItemData => {
            currItemData.h = parseInt(e.target.value) || 0
            return {
                ...currItemData
            }
        })
    }

    const setHeight = h => {
        if (h >= minH && h <= maxH) {
            layouts.find(item => {
                if (item.i === currItemData.i) {
                    item.h = h
                }
            })

            setLayouts(JSON.parse(JSON.stringify(layouts)))

            setCurrItemData(currItemData => {
                currItemData.h = h
                return {
                    ...currItemData
                }
            })
        }

    }

    const blurWidthInp = e => {
        let w = parseInt(currItemData.w)

        if (w < minW || w > maxW) {
            setWtipsDis("block")

            wdithRef.current.focus()
        } else {
            setWtipsDis("none")
        }

        console.log("blurWidthInp", parseInt(e.target.value));

        setWidth(parseInt(e.target.value) || 0)
    }

    const blurHeightInp = e => {
        let h = parseInt(currItemData.h)

        if (h < minH || h > maxH) {
            setHtipsDis("block")

            heightRef.current.focus()
        } else {
            setHtipsDis("none")

        }
        setHeight(parseInt(e.target.value) || 0)
    }

    const delLayout = i => {
        const _layouts = layouts.filter(item => item.i !== i)

        setLayouts(_layouts)
        setCurrGridItem(null)
        setCurrItemData(null)
    }

    const resizeStopHandle = (layout, oldItem, newItem) => {
        currItemData.w = newItem.w
        currItemData.h = newItem.h

        dataMap[currItemData.i] = currItemData

        setCurrItemData(currItemData)
        setDataMap(dataMap)
    }

    const selectFieldsName = (cid) => {
        const newField = fields.find(item => item.id == cid)
        const newID = newField.id + ""
        const oldId = currGridItem.i

        delete dataMap[oldId]

        layouts.forEach(item => {
            if (item.i == oldId) {
                item.i = newID
            }
        })

        setLayouts(JSON.parse(JSON.stringify(layouts)))

        currItemData.i = newID
        currItemData.name = newField.name
        currItemData.showInfo = newField?.sampledate ?? ""
        setCurrItemData({ ...currItemData })

        dataMap[currItemData.i] = currItemData
        setDataMap(JSON.parse(JSON.stringify(dataMap)))

        currGridItem.i = newID
        setCurrGridItem({ ...currGridItem })
    }

    const addFields = () => {
        const defaultValue = layouts.map(item => item.i)

        console.log("defaultValue", defaultValue);

        makeCheckModal({
            title: I18N("modal.title"),
            colNameStr: I18N("modal.fieldName"),
            checkedStr: I18N("modal.selected"),
            clearStr: I18N("modal.clear"),
            sureStr: I18N("op.sure"),
            cancelStr: I18N("op.cancel"),
            checkList: fields,
            defaultValue,
        }).then(res => {
            // console.log("确定", res);
            addFieldsHandle(res.fields, res.ids)
        }).catch(res => {
            // console.log("取消", res);
        })
    }

    const addFieldsHandle = (selectedfields, ids) => {
        setCurrGridItem(null)
        setCurrItemData(null)

        const _layouts = layouts.filter(item => ids.indexOf(item.i) > -1)

        const _layoutsIDs = []

        let maxY = 0

        _layouts.forEach(item => {
            _layoutsIDs.push(item.i)
            maxY = Math.max(maxY, item.y + item.h)
        })

        selectedfields.forEach(field => {
            const fieldID = field.id + ""
            if (_layoutsIDs.indexOf(fieldID) == -1) {
                console.log("field", field);
                _layouts.push({
                    i: fieldID,
                    x: 0,
                    y: maxY,
                    w: cardW,
                    h: 26
                })
                maxY += 26

                dataMap[fieldID] = {
                    i: fieldID,
                    name: field.name,
                    showInfo: field.sampledate ?? "",
                    aftercontent: "",
                    align: 1,
                    beforecontent: "",
                    bold: false,
                    fontSize: "14",
                    x: 0,
                    y: maxY,
                    w: cardW,
                    h: 26
                }
            }
        })

        setLayouts(_layouts)
        setDataMap(dataMap)
    }

    useEffect(() => {
        if (currItemData) {
            dataMap[currItemData.i] = currItemData
            setDataMap({
                ...dataMap
            })
        }
    }, [currItemData])

    return (
        <div className="edit-wrapper">
            <div className="main">
                <div className="card-box">
                    <div className="edit-card">
                        <GridLayout
                            className={`layout`}
                            layout={layouts}
                            cols={cardW}
                            rowHeight={1}
                            width={cardW}
                            margin={[0, 0]}
                            onLayoutChange={onLayoutChange}
                            onResizeStop={resizeStopHandle}
                            style={{
                                background: cardStyle.backgroundcolor,
                                boxShadow: "0 0 0px 1px " + cardStyle.bordercolor,
                            }}
                        >
                            {
                                layouts.map(item => {
                                    return (
                                        <div className={"card-info-box " + ((currGridItem?.i ?? null) === item.i ? "selected" : "")} key={item.i} onClick={() => { clickCurrGrid(item) }}>
                                            {
                                                isImg(item.i) && (
                                                    <div className="info" style={{ justifyContent: "center" }}>
                                                        <img style={{
                                                            width: Math.min(item.w - 8, item.h - 8) + "px",
                                                            height: Math.min(item.w - 8, item.h - 8) + "px"
                                                        }} src={"./" + dataMap[item.i].showInfo} alt={I18N("edit.head")} />
                                                    </div>
                                                )
                                            }
                                            {
                                                !isImg(item.i) && (
                                                    <div className="info" style={{
                                                        justifyContent: dataMap[item.i].align == 1 ? "start" : (dataMap[item.i].align == 2 ? "center" : "end"),
                                                        padding: "0 4px"
                                                    }}>
                                                        <div className="text-box" style={{
                                                            fontSize: dataMap[item.i].fontSize + "px",
                                                            fontWeight: dataMap[item.i].bold ? 600 : 100,
                                                            // textAlign: dataMap[item.i].align == 1 ? "left" : (dataMap[item.i].align == 2 ? "center" : "right")
                                                        }}>
                                                            {lastShowInfo(dataMap[item.i])}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            <Icon className="close-icon" onClick={() => { delLayout(item.i) }} type="close-solid" />
                                        </div>
                                    )
                                })
                            }
                        </GridLayout>
                        {
                            cardStyle.topbordercolor && (
                                <div className="topBar" style={{ background: cardStyle.topbordercolor }}></div>
                            )
                        }
                    </div>
                    <div className="add-fields" onClick={addFields}>
                        <Icon type="add" />
                        <span>{I18N("edit.addField")}</span>
                    </div>
                </div>
                {
                    (currItemData && layouts.length > 0) && (
                        <div className="attr-box">
                            <div className="form-row">
                                <div className="label">{I18N("edit.fieldName")}：</div>
                                <div className="form-item">
                                    <Select onSelect={selectFieldsName} value={currItemData?.i ?? null} style={{ width: "240px" }} borderType="bordered" placeholder={I18N("edit.fieldTips")}>
                                        {
                                            fields.map(item => {
                                                if (!dataMap[item.id] || item.id == (currGridItem?.i ?? null)) {
                                                    return (
                                                        <Option value={item.id + ""} key={item.id} item={item}>{item.name}</Option>
                                                    )
                                                }
                                            })
                                        }
                                    </Select>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="label">{I18N("edit.size")}：</div>
                                <div className="form-item">
                                    <InputNumber ref={wdithRef}
                                        onBlur={blurWidthInp}
                                        onChange={changeWidth}
                                        value={currItemData.w + ""}
                                        style={numInpStyle}
                                        borderType="bordered"
                                        min={minW} max={maxW}
                                        suffix={I18N("edit.width")}
                                    />
                                    <span style={{ left: 0, display: wtipsDis }} className="size-tips">{I18N("edit.wRange")}</span>
                                    <InputNumber ref={heightRef}
                                        onBlur={blurHeightInp}
                                        onChange={changeHeight}
                                        value={currItemData.h + ""}
                                        style={numInpStyle}
                                        borderType="bordered"
                                        min={minH} max={maxH}
                                        suffix={I18N("edit.height")}
                                    />
                                    <span style={{ left: "72px", display: htipsDis }} className="size-tips">{I18N("edit.hRange")}</span>
                                    <Tooltip style={tipsIconStyle} placement="bottom" tip={
                                        <>
                                            <p>{I18N("edit.valRange")}：</p>
                                            <p>{I18N("edit.width")}：20~180；{I18N("edit.height")}：20~{maxH}</p>
                                        </>
                                    }>
                                        <Icon type="tips" />
                                    </Tooltip>
                                </div>
                            </div>
                            {

                                !isImg(currItemData.i) && (
                                    <>
                                        <div className="form-row">
                                            <div className="label">{I18N("edit.fontSet")}：</div>
                                            <div className="form-item">
                                                <div className="size-box">
                                                    <Select onSelect={selectFontSize} value={currItemData.fontSize} style={fontSizeStyle} borderType="bordered" placeholder={I18N("edit.fontSetTip")}>
                                                        <Option value="12">12</Option>
                                                        <Option value="14">14</Option>
                                                        <Option value="16">16</Option>
                                                    </Select>
                                                </div>
                                                <div className="bold-box">
                                                    <span className={"bold " + (currItemData.bold ? "selected" : "")} onClick={changeBold}>B</span>
                                                </div>
                                                <div className="align-box">
                                                    <Icon onClick={() => { selectAlign(1) }} className={"icon " + (currItemData.align === 1 ? "selected" : "")} type="align-left" />
                                                    <Icon onClick={() => { selectAlign(2) }} className={"icon " + (currItemData.align === 2 ? "selected" : "")} type="align-center" />
                                                    <Icon onClick={() => { selectAlign(3) }} className={"icon " + (currItemData.align === 3 ? "selected" : "")} type="align-right" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="splice-line"></div>
                                        <div className="form-row">
                                            <div className="label">{I18N("edit.showInfo")}：</div>
                                            <div className="form-item">
                                                <Input onChange={changeBeforecontent} value={currItemData.beforecontent} borderType="bordered" className="pre-content" />
                                                <span className="middle-content">+{currItemData.name + ""}+</span>
                                                <Input onChange={changeAftercontent} value={currItemData.aftercontent} borderType="bordered" className="after-content" />
                                            </div>
                                        </div>
                                        <div className="tips-row">
                                            <div className="tips-box">
                                                <span className="text">{I18N("edit.eg")}：</span>
                                                <span className="box">{I18N("edit.personTitle")}：</span>
                                                <span className="text">+{I18N("edit.personField")}+</span>
                                                <span className="box">{I18N("edit.personUnit")}</span>
                                                <span className="text">
                                                    <Icon className="icon" type="back" />
                                                    {I18N("edit.personTitle")}：128{I18N("edit.personUnit")}
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                )
                            }

                        </div>
                    )
                }
                {
                    (!currItemData || layouts.length === 0) && (
                        <div className="attr-box">
                            <div className="not-select">
                                <Icon type="double-arrow-left" />
                                <span>{I18N("edit.tips")}</span>
                            </div>
                        </div>
                    )
                }


            </div>
            <div className="btn">
                <Button style={{ margin: "0 6px" }} onClick={cancelHanle} type="ghost" >{I18N("op.cancel")}</Button>
                <Button style={{ margin: "0 6px" }} disabled={layouts.length === 0} onClick={sureHandle} type="primary">{I18N("op.save")}</Button>
            </div>
        </div>
    );
}

export default EditCard;